export const compareObj = (a, b) => {
  const aKeys = Object.keys(a).sort();
  const bKeys = Object.keys(b).sort();
  if (aKeys.length !== bKeys.length) {
    return false;
  }
  if (aKeys.join("") !== bKeys.join("")) {
    return false;
  }
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < aKeys.length; i++) {
    if (a[aKeys[i]] !== b[bKeys[i]]) {
      return false;
    }
  }
  return true;
};

export const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const orderByDes = (arr, key) =>
  arr.sort((b, a) => new Date(b[key]) - new Date(a[key]));

export const orderByAsc = (arr, key) =>
  arr.sort((a, b) => new Date(b[key]) - new Date(a[key]));

export const loadScript = (url) =>
  new Promise((resolve, reject) => {
    let ready = false;
    if (!document) {
      reject(new Error("Document was not defined"));
    }
    const tag = document.getElementsByTagName("script")[0];
    const script = document.createElement("script");

    script.type = "text/javascript";
    script.src = url;
    script.async = true;
    script.onreadystatechange = () => {
      if (!ready) {
        ready = true;
        resolve(script);
      }
    };
    script.onload = script.onreadystatechange;

    script.onerror = (msg) => {
      console.log(msg);
      reject(new Error("Error loading script."));
    };

    script.onabort = (msg) => {
      console.log(msg);
      reject(new Error("Script loading aboirted."));
    };

    if (tag.parentNode != null) {
      tag.parentNode.insertBefore(script, tag);
    }
  });

export const formatterPrice = (e) => {
  if (!e || Number.isNaN(e)) return e;

  return new Intl.NumberFormat("en-MX", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(e);
};

export const getIva = (mount) => {
  const IVA = 0.0116;
  return mount * IVA;
};

export const getCommissionConeckta = (mount) => {
  const COMMISSION = 0.029;
  return mount * COMMISSION + 2.5 + getIva(mount);
};

export const addYears = (time, years) => {
  const date = new Date(time);
  date.setFullYear(date.getDate() + years);
  return date;
};

export const removeYears = (time, years) => {
  const date = new Date(time);
  date.setFullYear(date.getDate() - years);
  return date;
};

export const addDays = (time, days) => {
  const date = new Date(time);
  date.setDate(date.getDate() + days);
  return date;
};

export const removeDays = (time, days) => {
  const date = new Date(time);
  date.setDate(date.getDate() - days);
  return date;
};

export const addHours = (time, hours) => {
  const date = new Date(time);
  date.setHours(date.getHours() + hours);
  return date;
};

export const removeHours = (time, hours) => {
  const date = new Date(time);
  date.setHours(date.getHours() - hours);
  return date;
};

export const addMinutes = (time, minutes) => {
  const date = new Date(time);
  date.setMinutes(date.getMinutes() + minutes);
  return new Date(date).toLocaleTimeString();
};

export const removeMinutes = (time, minutes) => {
  const date = new Date(time);
  date.setMinutes(date.getMinutes() - minutes);
  return new Date(date).toLocaleTimeString();
};
